<!-- 服务信息 -->
<template>
  <div class="service-info">
    <el-form :model="queryParams" :rules="rules" ref="BusinessInfoForm">
      <el-form-item label="咨询服务：" label-width="140px">
        <Editorbar v-model="queryParams.consultationService" />
      </el-form-item>

      <el-form-item label="实施服务：" label-width="140px">
        <Editorbar v-model="queryParams.implementationService" />
      </el-form-item>

      <el-form-item label="税费信息：" label-width="140px">
        <Editorbar v-model="queryParams.taxInformation" />
      </el-form-item>

      <el-form-item label="物流服务：" label-width="140px">
        <Editorbar v-model="queryParams.logisticsService" />
      </el-form-item>

      <el-form-item label="培训服务：" label-width="140px">
        <Editorbar v-model="queryParams.trainingService" />
      </el-form-item>

      <el-form-item label="售后服务：" label-width="140px">
        <Editorbar v-model="queryParams.afterSalesService" />
      </el-form-item>

      <el-form-item label="其他服务：" label-width="140px">
        <Editorbar v-model="queryParams.otherServices" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// components
import Editorbar from "@/components/Editorbar.vue";
// api
import { findServerInfo, updateServerInfo } from "@/api/product.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Editorbar
  },
  data() {
    //这里存放数据
    return {
      queryParams: {
        afterSalesService: "", // 售后服务
        consultationService: "", // 咨询服务
        implementationService: "", // 实施服务
        logisticsService: "", // 物流服务
        otherServices: "", // 其他服务
        productCode: "",
        taxInformation: "", // 税费信息
        trainingService: "" // 培训服务
      },
      rules: {},
      isInit: false
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      findServerInfo({ productCode: this.$route.query.productCode }).then(
        res => {
          if (res.code == 200) {
            this.isInit = true;
            this.queryParams = res.data;
          }
        }
      );
    },
    submit() {
      if (!this.queryParams.productCode) {
        this.queryParams.productCode = this.$route.query.productCode;
      }

      this.$modal.loading('正在保存数据，请稍候...');
      updateServerInfo(this.queryParams).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
